import { MotifTable } from "../../../assets/lib/motif";
import "./Table.scss";
import { useEffect, useState } from "react";

export function Table({
  rowData,
  colDefs,
  pagesize = 10,
  rowClassRules,
  selectionChanged,
  forceUpdate = crypto.randomUUID(),
  rowDragged,
  rowSelect,
  draggable,
  loading,
  pagination = true,
  suppressMovableColumns,
  onGridReady = () => {},
}) {
  const [gridApi, setGridApi] = useState();

  const gridOptions = {
    overlayNoRowsTemplate:
      "<div class='decarb-table-no-rows'>No records found</div>",
  };

  useEffect(() => {
    if (gridApi && rowData && rowData.length > 0) {
      gridApi.setGridOption("rowData", rowData);
      gridApi.redrawRows();
    }
  }, [rowData, gridApi, forceUpdate]);

  function handleGridReady(params) {
    setGridApi(params.api);
    onGridReady(params);
  }

  function getPageSizes(rowCount) {
      const sizes = [5, 10, 20, 50, 100, 200, 500, 1000];
      const result = [];
      for (let size of sizes) {
        result.push(size);
        if (size >= rowCount) break;
      }
      return result;
  }

  return (
    <MotifTable
      suppressRowTransform={true}
      suppressRowHoverHighlight={true}
      suppressCellFocus
      suppressRowClickSelection
      rowDragEntireRow={draggable}
      suppressDragLeaveHidesColumns={true}
      rowDragManaged={true}
      suppressMoveWhenRowDragging={true}
      suppressMovableColumns={suppressMovableColumns || false}
      rowData={rowData}
      columnDefs={colDefs}
      pagination={pagination && rowData.length > 5}
      onGridReady={handleGridReady}
      paginationPageSize={getPageSizes(rowData.length)[0]}
      paginationPageSizeSelector={
        rowData && rowData.length > 5 ? getPageSizes(rowData.length) : [0]
      }
      onRowSelected={selectionChanged}
      onRowDragEnd={rowDragged}
      rowHeight={72}
      rowSelection={rowSelect}
      editType={"fullRow"}
      headerHeight={72}
      gridOptions={gridOptions}
      rowClassRules={rowClassRules}
      domLayout="normal"
      loading={loading ? loading : false}
      overlayLoadingTemplate={`<div data-testid="table-loading" class="motif-progress-loader decarb-loading-indicator  decarb-loading-indicator-transparent decarb-table-no-rows" data-motif-progress-loader="true"><div class="motif-progress-loader-type"><div class="motif-progress-loader-content"><div class="motif-progress-loader-square"></div><div class="motif-progress-loader-square"></div><div class="motif-progress-loader-square"></div></div></div></div>`}
      firstColumnBorderRight
      tooltipShowDelay={0}
      tooltipHideDelay={3000}
    />
  );
}
